module.exports = __webpack_public_path__ + "img/step4-mobile-en.a8f55ba5.webp";